import React from "react";
import UserProfileDetails from "../components/UserProfileDetails/UserProfileDetails";

const UserProfile = () => {
  return (
    <>
    <UserProfileDetails />
    </>
  );
};

export default UserProfile;
